import { Close } from '@mui/icons-material';
import { Autocomplete, Backdrop, Button, CircularProgress, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import styles from "./BrPriv.module.css";
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useCreateMappingMutation, useGetMappingByIdQuery } from '../../Store/Services/BrPrivService';
import { useGetAllPrivilegesQuery } from '../../Store/Services/privilegeService';
import { useGetAllRolesQuery } from '../../Store/Services/RoleService';


const schema = yup.object({
    brId:yup.string().notOneOf(['init']).required(""),
}).required();

const EditBrPriv = ({ handleClose }) => {

    const [privileges, setPrivileges] = useState([]);
    const [deletedPriv, setDeletedPriv] = useState([])
    const [newPriv, setNewPriv] = useState([])

    const mappingId = useSelector((state) => state.brPriv.selectedBrPriv);

    const { data: mappingDetails, isSuccess, isLoading } = useGetMappingByIdQuery(mappingId);

    const {register, handleSubmit, reset, formState: { errors }} = useForm({
        resolver: yupResolver(schema),
    });

    const { data: roleData, isSuccess: roleSuccess } = useGetAllRolesQuery();
    const roles = roleData?.list?.map(type => (
        <MenuItem key={type.brId} value={type.brId}>{type.brName}</MenuItem>
    ));

    const { data: privilegeData, isSuccess: privSuccess, isLoading: privLoading } = useGetAllPrivilegesQuery();
    let privList
    if(privSuccess){
        privList = privilegeData?.map((priv) => ({ privId: priv.privilegeId, privName: priv.privilegeName }));
    }

    const [updateBrPriv] = useCreateMappingMutation();

    const initializeFields = () => {
      setPrivileges(mappingDetails?.priv?.map((priv) => ({ privId: priv.privId, privName: priv.privName, brPrivId: priv.brPrevId })));
    }

    useEffect(() => {
        if(isSuccess){
            reset({
                brId: mappingDetails?.brId
            })
            initializeFields()
        }
    }, [mappingDetails])

    const onSubmit = async (data) => {
        const dataSet = {
            ...data,
            newPrivIds: newPriv.map(priv => priv.privId),
            deletedIds: deletedPriv.map(priv => priv.brPrivId),
        }
        if(privileges.length !== 0){
            try {
                const respond = await updateBrPriv(dataSet).unwrap();
                // toast.success("BrPriv successfully added!");
                handleClose();
            } catch (err) {
                console.error("Failed to save the BrPriv: ", err);
                toast.error("Erorr, something went wrong!");
            }
        }
    };

    return (
        <div>
            <div className={styles.headingContainer}>
                <Typography fontWeight={600} variant={"h6"}>
                    Edit Privileges to Role Mapping
                </Typography>
                <IconButton className={styles.closeButton} onClick={handleClose} aria-label="Close">
                    <Close />
                </IconButton>
            </div>

            {roleSuccess&& isSuccess && roleSuccess && !privLoading && <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Role:</label>
                    {errors.brId && errors.brId.type === "notOneOf" && (<span className={styles.validation}> *</span>)}
                    <Select {...register("brId")} defaultValue={mappingDetails?.brId} className={styles.formInput} fullWidth size="small">
                        <MenuItem value="init">Select a Role</MenuItem>
                        {roles}
                    </Select>
                </div>

                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Privileges:</label>
                    {privileges?.length===0 && (<span className={styles.validation}> *</span>)}
                    <Autocomplete
                        className={styles.formInput}
                        onChange={(_, newPriv, reason, detail) => {
                            if (reason === 'removeOption') {
                              setDeletedPriv(prev => [...prev, detail.option])
                            } else if (reason === 'selectOption') {
                              setNewPriv(prev => [...prev, detail.option])
                            }
                            setPrivileges(newPriv.map((priv) => ({ privId: priv.privId, privName: priv.privName, brPrivId: priv.brPrivId })));
                        }}
                        size="small"
                        multiple
                        filterSelectedOptions
                        isOptionEqualToValue={(option, value) =>
                            option.privName === value.privName
                        }
                        value={privileges}
                        options={privList}
                        getOptionLabel={(option) => option.privName}
                        renderInput={(params) => (
                            <TextField placeholder="User Privileges" {...params} />
                        )}
                    />
                </div>

                {/* Submit Button */}
                <div className={styles.buttonContainer}>
                    <Button type="submit" className={styles.submitButton} variant="contained" aria-label="Save">Save</Button>
                </div>
            </form>}
        </div>
    )
}

export default EditBrPriv